<template>
	<div class="container">
		<myHeader></myHeader>
		<div class="main">
			<div class="banner">
				<img src="../assets/banner/dynamic_banner.jpg" />
			</div>
			<div class="dynamic-list">
				<div class="item" v-for="(item, index) in dataList" :key="index" @click="toDynamicDetail(item.investmentInformationId)">
					<div class="title">
						{{ item.investmentInformationTitle }}
					</div>
					<div class="info">
						<span>{{ item.investmentInformationPublishTime }}</span>
					</div>
				</div>
				<div class="more-list" v-if="isMore" @click="loadMore()">查看更多</div>
				<div class="more-list" v-if="noMore">没有更多</div>
			</div>
		</div>
		<!-- 尾部 -->
		<myFooter></myFooter>
		<!-- 侧边悬浮 -->
		<sideFloat></sideFloat>
		<!-- 底部菜单 -->
		<bottomMenu></bottomMenu>
	</div>
</template>

<script>
	import {
		useRouter
	} from 'vue-router'
	import {
		ref,
		defineComponent
	} from 'vue'
	import {
		ElMessage
	} from 'element-plus'
	import { getDynamicList } from '@/axios/api'
	import myHeader from '@/components/layouts/myHeader'
	import myFooter from '@/components/layouts/myFooter'
	import bottomMenu from '@/components/layouts/bottomMenu'
	import sideFloat from '@/components/layouts/sideFloat'
	export default defineComponent({
		components: {
			myHeader,
			myFooter,
			bottomMenu,
			sideFloat
		},
		setup() {
			const router = useRouter();
			const dataList = ref('');
			const step = ref(10); //每次增加数量
			const count = ref(10); //初始化当前显示数量
			const isMore = ref(true);
			const noMore = ref(false);
			
			(function getListData() {
				getData();
				// 当前显示数量存入session
				sessionStorage.setItem('count', count.value);
			})();
			
			// 点击加载更多
			function loadMore() {
				// 当前显示数量
				count.value = parseInt(sessionStorage['count']) + step.value;
				// 当前显示数量存入session
				sessionStorage.setItem('count', count.value);
				getData();
			}
			
			function getData() {
				getDynamicList('/cdMapApi/api/park/dynamics/list', {
					
				}).then(function (res){
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						console.log('动态：',data)
						// 当前渲染数据列表
						dataList.value = data.slice(0, count.value)
						if (count.value >= data.length) {
							isMore.value = false
							noMore.value = true
						}
						
					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				})
			}
			// 招商动态内容
			function toDynamicDetail(dynamicId) {
				router.push({
					name: 'dynamicDetail',
					query: {
						dynamicId: dynamicId
					}
				})
			}

			return {
				isMore,
				noMore,
				loadMore,
				dataList,
				toDynamicDetail
			}
		}
	})
</script>

<style lang="scss" scoped>
	.container {
		height: auto;
		min-height: 100vh;
		margin: 0;
		padding: 0;

		.main {

			.banner {
				width: 100%;
				margin-bottom: 10px;
				overflow: hidden;

				img {
					width: 100%;
				}
			}

			.dynamic-list {
				padding: 0px 10px;

				.item {
					background: #fff;
					padding: 10px;
					border-bottom: #e9e9e9 1px dashed;

					.title {
						font-size: 16px;
						line-height: 25px;
						text-align: left;
						color: #333;
						word-wrap: break-word;
					}

					.info {
						display: flex;
						justify-content: space-between;
						padding: 5px 0px;
						color: #999;
					}
				}
				.more-list {
					line-height: 50px;
					text-align: center;
				}
			}
		}
	}
</style>